module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/store_images/5@2x_07438a03376f16b1bc1b5a7e9062bf9b.png";